import type { ReplacementOrderErrorCode } from "./replacement-order.constants";

export class ReplacementOrderSubmitError extends Error {
  public readonly code: ReplacementOrderErrorCode;
  public readonly existingOrderId?: string;

  public constructor(code: ReplacementOrderErrorCode, message: string, existingOrderId?: string) {
    super(message);
    this.name = "ReplacementOrderSubmitError";
    this.code = code;
    this.existingOrderId = existingOrderId;
  }
}
